// Add your JS customizations here
document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.e3-project-gallery').forEach((gallery) => {
		const mainButton = gallery.querySelector('.e3-project-gallery__main');
		const mainImage = mainButton ? mainButton.querySelector('img') : null;
		const thumbStrip = gallery.querySelector('.e3-project-gallery__thumb-strip');
		const thumbTrack = gallery.querySelector('.e3-project-gallery__thumbs');
		const thumbs = Array.from(gallery.querySelectorAll('.e3-project-gallery__thumb'));
		const thumbScrollPrev = gallery.querySelector('.e3-project-gallery__thumb-scroll--prev');
		const thumbScrollNext = gallery.querySelector('.e3-project-gallery__thumb-scroll--next');
		const prev = gallery.querySelector('.e3-project-gallery__nav--prev');
		const next = gallery.querySelector('.e3-project-gallery__nav--next');

		if (!mainButton || !mainImage || !thumbs.length) {
			return;
		}

		let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

		const setActive = (index) => {
			activeIndex = (index + thumbs.length) % thumbs.length;
			const thumb = thumbs[activeIndex];
			const fullSrc = thumb.dataset.fullSrc;

			if (fullSrc) {
				mainImage.src = fullSrc;
				mainImage.removeAttribute('srcset');
				mainImage.removeAttribute('sizes');
			}

			thumbs.forEach((item, itemIndex) => {
				item.classList.toggle('is-active', itemIndex === activeIndex);
			});

			thumb.scrollIntoView({
				behavior: 'smooth',
				block: 'nearest',
				inline: 'nearest',
			});
		};

		const updateThumbScrollState = () => {
			if (!thumbStrip || !thumbTrack) {
				return;
			}

			const maxScroll = thumbTrack.scrollWidth - thumbTrack.clientWidth;
			const scrollTolerance = 8;
			const hasOverflow = maxScroll > 2;
			thumbStrip.classList.toggle('has-overflow', hasOverflow);

			if (thumbScrollPrev) {
				thumbScrollPrev.classList.toggle('is-disabled', !hasOverflow || thumbTrack.scrollLeft <= scrollTolerance);
			}

			if (thumbScrollNext) {
				thumbScrollNext.classList.toggle('is-disabled', !hasOverflow || thumbTrack.scrollLeft >= maxScroll - scrollTolerance);
			}
		};

		const scrollThumbs = (direction) => {
			if (!thumbTrack) {
				return;
			}

			const maxScroll = thumbTrack.scrollWidth - thumbTrack.clientWidth;
			const isAtStart = thumbTrack.scrollLeft <= 8;
			const isAtEnd = thumbTrack.scrollLeft >= maxScroll - 8;

			if ((direction < 0 && isAtStart) || (direction > 0 && isAtEnd)) {
				updateThumbScrollState();
				return;
			}

			thumbTrack.scrollBy({
				left: direction * Math.max(thumbTrack.clientWidth * 0.75, 160),
				behavior: 'smooth',
			});
		};

		const openLightbox = () => {
			const thumb = thumbs[activeIndex];
			const src = thumb.dataset.fullscreenSrc || thumb.dataset.fullSrc || mainImage.src;
			const modal = document.createElement('div');
			const closeButton = document.createElement('button');
			const prevButton = document.createElement('button');
			const nextButton = document.createElement('button');
			const modalImage = document.createElement('img');

			modal.className = 'e3-project-lightbox';
			closeButton.className = 'e3-project-lightbox__close';
			closeButton.type = 'button';
			closeButton.setAttribute('aria-label', 'Sluiten');
			closeButton.textContent = '×';
			prevButton.className = 'e3-project-lightbox__nav e3-project-lightbox__nav--prev';
			prevButton.type = 'button';
			prevButton.setAttribute('aria-label', 'Vorige afbeelding');
			prevButton.textContent = '‹';
			nextButton.className = 'e3-project-lightbox__nav e3-project-lightbox__nav--next';
			nextButton.type = 'button';
			nextButton.setAttribute('aria-label', 'Volgende afbeelding');
			nextButton.textContent = '›';
			modalImage.src = src;
			modalImage.alt = mainImage.alt || '';
			modal.append(closeButton, prevButton, modalImage, nextButton);
			document.body.appendChild(modal);
			document.body.classList.add('e3-lightbox-open');

			const updateModalImage = () => {
				const activeThumb = thumbs[activeIndex];
				modalImage.src = activeThumb.dataset.fullscreenSrc || activeThumb.dataset.fullSrc || modalImage.src;
			};

			const close = () => {
				modal.remove();
				document.body.classList.remove('e3-lightbox-open');
				document.removeEventListener('keydown', onKeydown);
			};

			const move = (direction) => {
				setActive(activeIndex + direction);
				updateModalImage();
			};

			const onKeydown = (event) => {
				if (event.key === 'Escape') {
					close();
				}
				if (event.key === 'ArrowLeft') {
					move(-1);
				}
				if (event.key === 'ArrowRight') {
					move(1);
				}
			};

			closeButton.addEventListener('click', close);
			prevButton.addEventListener('click', () => move(-1));
			nextButton.addEventListener('click', () => move(1));
			modal.addEventListener('click', (event) => {
				if (event.target === modal) {
					close();
				}
			});
			document.addEventListener('keydown', onKeydown);
		};

		thumbs.forEach((thumb, index) => {
			thumb.addEventListener('click', () => setActive(index));
		});

		if (prev) {
			prev.addEventListener('click', () => setActive(activeIndex - 1));
		}

		if (next) {
			next.addEventListener('click', () => setActive(activeIndex + 1));
		}

		if (thumbScrollPrev) {
			thumbScrollPrev.addEventListener('click', () => scrollThumbs(-1));
		}

		if (thumbScrollNext) {
			thumbScrollNext.addEventListener('click', () => scrollThumbs(1));
		}

		if (thumbTrack) {
			thumbTrack.addEventListener('scroll', updateThumbScrollState);
			window.addEventListener('resize', updateThumbScrollState);
			thumbTrack.scrollLeft = 0;
			requestAnimationFrame(updateThumbScrollState);
		}

		mainButton.addEventListener('click', openLightbox);
		setActive(activeIndex);
	});
});
